/**
 * Sync status icon components (from Rev Callout component)
 */
export const ExclamationMarkTriangleIconFilled = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='14'
			height='14'
			viewBox='0 0 14 14'
			fill='none'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5.2438 1.54011C6.02428 0.153296 7.97582 0.153296 8.75563 1.54011L13.7257 10.3797C14.5055 11.7665 13.5297 13.5 11.9695 13.5H2.02997C0.469684 13.5 -0.50541 11.7665 0.274395 10.3797L5.2438 1.54011ZM7.00005 5.17842C7.13446 5.17842 7.26337 5.23321 7.35842 5.33074C7.45346 5.42827 7.50686 5.56055 7.50686 5.69847V8.29875C7.50686 8.43668 7.45346 8.56896 7.35842 8.66649C7.26337 8.76402 7.13446 8.81881 7.00005 8.81881C6.86564 8.81881 6.73673 8.76402 6.64168 8.66649C6.54664 8.56896 6.49324 8.43668 6.49324 8.29875V5.69847C6.49324 5.56055 6.54664 5.42827 6.64168 5.33074C6.73673 5.23321 6.86564 5.17842 7.00005 5.17842ZM7.00005 10.899C7.13446 10.899 7.26337 10.8442 7.35842 10.7467C7.45346 10.6492 7.50686 10.5169 7.50686 10.379C7.50686 10.241 7.45346 10.1088 7.35842 10.0112C7.26337 9.91371 7.13446 9.85892 7.00005 9.85892C6.86564 9.85892 6.73673 9.91371 6.64168 10.0112C6.54664 10.1088 6.49324 10.241 6.49324 10.379C6.49324 10.5169 6.54664 10.6492 6.64168 10.7467C6.73673 10.8442 6.86564 10.899 7.00005 10.899Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const InfoIconOutline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'>
			<path
				d='M7.41667 7.41667L7.44856 7.40111C7.54829 7.35129 7.66021 7.33108 7.77107 7.3429C7.88193 7.35471 7.98709 7.39805 8.07408 7.46778C8.16107 7.5375 8.22626 7.6307 8.26193 7.73632C8.2976 7.84195 8.30225 7.95559 8.27533 8.06378L7.72467 10.2696C7.69756 10.3778 7.70206 10.4915 7.73765 10.5973C7.77324 10.7031 7.83841 10.7964 7.92544 10.8662C8.01247 10.9361 8.11771 10.9795 8.22866 10.9913C8.33962 11.0032 8.45164 10.9829 8.55144 10.933L8.58333 10.9167M15 8C15 8.91925 14.8189 9.82951 14.4672 10.6788C14.1154 11.5281 13.5998 12.2997 12.9497 12.9497C12.2997 13.5998 11.5281 14.1154 10.6788 14.4672C9.82951 14.8189 8.91925 15 8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.82951 1 8.91925 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8ZM8 5.08333H8.00622V5.08956H8V5.08333Z'
				stroke='#666666'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
		</svg>
	);
};

export const InfoIconFilled = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='14'
			height='14'
			viewBox='0 0 14 14'
			fill='none'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0 7C0 3.13385 3.13385 0 7 0C10.8662 0 14 3.13385 14 7C14 10.8662 10.8662 14 7 14C3.13385 14 0 10.8662 0 7ZM6.25046 5.96472C7.07323 5.55333 8.0001 6.29713 7.77682 7.18954L7.2678 9.22564L7.29795 9.21128C7.42446 9.15566 7.56752 9.15082 7.69751 9.19775C7.82749 9.24468 7.93446 9.3398 7.99626 9.46341C8.05807 9.58702 8.06998 9.72966 8.02953 9.86181C7.98909 9.99395 7.89938 10.1055 7.77897 10.1733L7.75026 10.1891C6.92677 10.6005 5.9999 9.85672 6.22318 8.96431L6.73292 6.92821L6.70277 6.94256C6.63926 6.97786 6.56926 6.99994 6.49699 7.00747C6.42472 7.015 6.35167 7.00782 6.28225 6.98637C6.21283 6.96492 6.14846 6.92965 6.09304 6.88266C6.03761 6.83568 5.99226 6.77797 5.95973 6.713C5.92719 6.64803 5.90814 6.57715 5.90373 6.50462C5.89932 6.43209 5.90963 6.35942 5.93404 6.29099C5.95845 6.22255 5.99646 6.15976 6.04579 6.1064C6.09511 6.05305 6.15472 6.01022 6.22103 5.98051L6.25046 5.96472ZM7 4.84615C7.14281 4.84615 7.27977 4.78942 7.38075 4.68844C7.48173 4.58746 7.53846 4.4505 7.53846 4.30769C7.53846 4.16488 7.48173 4.02792 7.38075 3.92694C7.27977 3.82596 7.14281 3.76923 7 3.76923C6.85719 3.76923 6.72023 3.82596 6.61925 3.92694C6.51827 4.02792 6.46154 4.16488 6.46154 4.30769C6.46154 4.4505 6.51827 4.58746 6.61925 4.68844C6.72023 4.78942 6.85719 4.84615 7 4.84615Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const CheckmarkCircleIconFilled = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M1 8C1 4.13385 4.13385 1 8 1C11.8662 1 15 4.13385 15 8C15 11.8662 11.8662 15 8 15C4.13385 15 1 11.8662 1 8ZM10.5918 6.69764C10.6349 6.64024 10.666 6.57481 10.6835 6.50519C10.7009 6.43558 10.7042 6.36318 10.6933 6.29225C10.6823 6.22133 10.6573 6.15331 10.6197 6.09219C10.5821 6.03108 10.5326 5.9781 10.4742 5.93636C10.4159 5.89463 10.3497 5.86499 10.2797 5.84919C10.2097 5.83338 10.1372 5.83173 10.0666 5.84433C9.99595 5.85693 9.92853 5.88352 9.8683 5.92255C9.80808 5.96158 9.75626 6.01225 9.7159 6.07159L7.39262 9.3239L6.22667 8.15795C6.12459 8.06284 5.98958 8.01105 5.85009 8.01352C5.71059 8.01598 5.57749 8.07249 5.47884 8.17114C5.38018 8.2698 5.32367 8.4029 5.32121 8.54239C5.31875 8.68189 5.37053 8.8169 5.46564 8.91897L7.08103 10.5344C7.1363 10.5896 7.20293 10.6321 7.2763 10.659C7.34967 10.6859 7.42801 10.6965 7.50588 10.6901C7.58376 10.6837 7.6593 10.6604 7.72727 10.6218C7.79524 10.5833 7.85401 10.5304 7.89949 10.4669L10.5918 6.69764Z'
				fill='currentColor'
			/>
		</svg>
	);
};

/**
 * Minus circle icon for blocked/draft status
 * A circular icon with a minus sign in the center
 * Uses currentColor to inherit the tag's accent color
 */
export const MinusCircleIcon = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='14'
			height='14'
			viewBox='0 0 14 14'
			fill='none'>
			<circle cx='7' cy='7' r='6.5' fill='currentColor' />
			<path
				d='M4.5 7H9.5'
				stroke='white'
				strokeWidth='1.2'
				strokeLinecap='round'
			/>
		</svg>
	);
};
